// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { FxMultiButtons } from 'axp-fx-common'; // eslint-disable-line no-unused-vars

const Welcome = ({ onContinueClick }) => (
  <div className="margin-4-t">
    <Heading
      level={1}
      headingStyle="heading5"
      style={{ fontWeight: '500', color: '#00175A' }}
    >
      Welcome to the Registration Page for File Exchange Express
    </Heading>
    <div className="pad-tb">
      <h3 className="label-2 dls-bright-blue">Instructions</h3>
      <p className="pad-tb">
        This registration process will allow you to log into the File Exchange
        Express to manage file transfer related information. This is not the
        username and password used to transfer files.
      </p>
      <div>
        <Heading level={5} headingStyle="heading2">
          Next steps in the registration process require you:
        </Heading>
        <ul className="pad-tb">
          <li className="pad-1-l">Add your name and phone number</li>
          <li className="pad-1-l">
            Create your User ID, Password, and Security Pin
          </li>
        </ul>
      </div>
      <div>
        <Heading level={5} headingStyle="heading2">
          Logging into File Exchange Express will allow you to:
        </Heading>
        <ul className="pad-tb">
          <li className="pad-1-l">
            Update contact information for yourself and your colleagues
          </li>
          <li className="pad-1-l">
            Update your password for File Exchange Express
          </li>
          <li className="pad-1-l">Follow up on requested actions</li>
        </ul>
      </div>
      <div>
        <Heading level={5} headingStyle="heading2">
          There will be additional functions available in File Exchange Express in
          the future, to include:
        </Heading>
        <ul className="pad-tb">
          <li className="pad-1-l">
            Communication with your American Express point of contact
          </li>
          <li className="pad-1-l">Manage your remote server information</li>
          <li className="pad-1-l">Track files</li>
        </ul>
      </div>
    </div>

    <FxMultiButtons
      primaryButtonLabel="Continue"
      onPrimaryButtonClick={onContinueClick}
      justifyButtons="end"
    />
  </div>
);

Welcome.propTypes = {
  onContinueClick: PropTypes.func.isRequired,
};

export default Welcome;
